import defaultState from './state'
import Vue from 'vue'

export default {
  setAccountingPeriods: (state, payload) => {
    state.accountingPeriods = payload
  },
  setIsCallingAccounting: (state, payload) => { state.setIsCallingCategories = payload },
  clearStoreData: (state) => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }
}
